import { IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APGoalSets, IGoalSet } from '../../global/builders/ap_goal_sets_builder';
import { IAPGoalSetsDatasource } from '../../global/datasources/ap_goal_sets_datasource';

interface IStudentGoalSet {
  id: number;
  title: string;
  studentGoalSetId: number;
}
export class APGoalSetsQuery implements IQuery {
  private __result: {
    goalSets: IStudentGoalSet[];
  };

  constructor(QueryMediator: IQueryMediator, private ngAPGoalSetstDatasource: IAPGoalSetsDatasource) {
    QueryMediator.registerQuery(this, ngAPGoalSetstDatasource);
  }

  getGoalSetsData(goalSetsData: APGoalSets[]) {
    return _4.map(goalSetsData, ({ goal_set, id: student_goal_set_id }) => {
      const { id, display_name: title } = goal_set;
      return { id, title, studentGoalSetId: student_goal_set_id };
    });
  }

  run(): this {
    const goalSetsData = this.ngAPGoalSetstDatasource.values();
    const goalSets: IStudentGoalSet[] = this.getGoalSetsData(goalSetsData);
    this.__result = {
      goalSets
    };
    return this;
  }
  get result() {
    return this.__result;
  }
}

angular.module('capability-ng-academic-planner').service('ngAPGoalSetsQuery', APGoalSetsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/queries/ap_goal_sets_query.ts